module.exports = __webpack_public_path__ + "img/trophy4.png";